// TODO(): type OutputAction payloads
export enum OutputAction {
  Handshake = 'Handshake',
  Logout = 'Logout',
  Downloads_GetAll = 'Downloads_GetAll',
  Download_Start = 'Download_Start',
  Download_Delete = 'Download_Delete',
  Download_Pause = 'Download_Pause',
  Download_Resume = 'Download_Resume',
  Download_Play = 'Download_Play',
  Download_Cancel = 'Download_Cancel',
  Download_Retry = 'Download_Retry',
  Settings_GetAll = 'Settings_GetAll',
  Settings_DownloadQuality = 'Settings_DownloadQuality',
  Settings_DownloadOnMobileData = 'Settings_DownloadOnMobileData',
  Settings_3PNotice = 'Settings_3PNotice',
  Settings_Feedback = 'Settings_Feedback',
}
